const KEY = 'nova-reminder-surfaced-v1'

type Ledger = Record<string, string> // reminderId -> ISO date last surfaced

function read(): Ledger {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? (JSON.parse(raw) as Ledger) : {}
  } catch {
    return {}
  }
}

function write(l: Ledger): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(l))
  } catch {
    /* ignore quota/availability errors */
  }
}

export function wasSurfacedToday(id: string, todayIso: string): boolean {
  return read()[id] === todayIso
}

export function markSurfaced(id: string, todayIso: string): void {
  const l = read()
  l[id] = todayIso
  write(l)
}

export function clearSurfaced(id: string): void {
  const l = read()
  if (id in l) {
    delete l[id]
    write(l)
  }
}

/** Drop entries whose date is before today (keep only today's). */
export function pruneLedger(todayIso: string): void {
  const l = read()
  let changed = false
  for (const [id, day] of Object.entries(l)) {
    if (day < todayIso) {
      delete l[id]
      changed = true
    }
  }
  if (changed) write(l)
}
